<div role="main">
	<div class="container page-contents">
		<div class="row align-items-center">
		<div class="col-12" style="margin-bottom:0.5cm;margin-top:0.5cm" *ngIf="environment.clusterId === 'specialized-prod'">
			<div class="color-alert-critical text-center">
				<div class="row align-items-center">
					<div class="col-12">
						<div class="py-1 legal-alert">
							To provision Staging please visit https://admin.staging.specialized.com
						</div>
					</div>
				</div>
			 </div>
		</div>
			<div class="col">
				<h2 class="page-title" i18n="company page/menu title" i18n>App Administration</h2>
			</div>
		</div>

		<div class="row">
			<div class="col">
				<hr class="mt-0"/>
			</div>
		</div>


        <div class="row justify-content-center">
            <div class="col-12 text-center" *ngIf="!company">
                <ng-container>
                    <div class="text-danger my-4" i18n>You are not an App Administrator for the company.</div>
                </ng-container>
            </div>
        </div>

		<div class="row justify-content-center">
			<div class="col-12" *ngIf="company">
				<mat-card class="company-card">
					<app-company-overview [company]="company"></app-company-overview>
				</mat-card>
			</div>
		</div>
	</div>
</div>
